import React from 'react';
import { t, getContactNumber, getCurrentLocale,getCreateAccountURL,getLoginURL } from '@insight/toolkit-utils';
import { INSIGHT_CURRENT_LOCALE_COOKIE_NAME } from '../../constants';
import { CalloutBox } from '@insight/toolkit-react';

function CalloutActions({ isCallForPrice }) {
  const locale = getCurrentLocale(INSIGHT_CURRENT_LOCALE_COOKIE_NAME) || 'en_US'; // Default locale if null or undefined

  const contactNumber = getContactNumber(locale) || '';
  const callForPriceLabelText = t('Contact us for pricing & availability');
  const callForPriceLabelNumber = `${t('Call')} ${contactNumber} ${t('for Price')}`;

  return (
    <CalloutBox
      isCallForPrice={isCallForPrice}
      callForPriceLabel={callForPriceLabelText}
      callForPriceLabelNumber={callForPriceLabelNumber}
      contactNumberValue={contactNumber}
      loginLink={getLoginURL()}
      accountLink={getCreateAccountURL()}
    />
  );
}

export default CalloutActions;